import { useTranslation } from 'react-i18next'
import { AppLink, AppSpan, AppText, Button, Form } from 'src/style'
import { TextField, Box } from 'src/componentv2'
import { ResetInput } from './types'

interface ForgotPasswordFormProps {
    resetInput: ResetInput
    setReset: (key: keyof ResetInput) => (value: string) => void
    resetIdFieldError: (key: 'ibInstitutionCode' | 'email') => string | undefined
    handleSendOtp: () => void
    backToLogin: () => void
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
                                                                   resetInput, setReset, resetIdFieldError, handleSendOtp, backToLogin
                                                               }) => {
    const { t } = useTranslation()

    return (
        <>
            <AppText
                color='#101828' textSize='3' fontWeight='600' bottomPadding='0.7'
                className='login-title'
            >
                {t('login.forgotPasswordForm.title')}
            </AppText>
            <AppSpan
                color='#667085' textSize='1.6'
                className='login-instruction'
            >
                {t('login.forgotPasswordForm.instruction')}
            </AppSpan>

            <Form onSubmit={(e: any) => { e.preventDefault(); handleSendOtp() }}>
                <Box topMargin="2.4">
                    <TextField
                        label={t('login.forgotPasswordForm.institutionCodeLabel')}
                        placeholder={t('login.forgotPasswordForm.institutionCodePlaceholder')}
                        value={resetInput.ibInstitutionCode}
                        onChange={setReset('ibInstitutionCode')}
                        type="number"
                        error={resetIdFieldError('ibInstitutionCode')}
                    />
                </Box>

                <Box topMargin="1.6">
                    <TextField
                        label={t('login.forgotPasswordForm.emailLabel')}
                        placeholder={t('login.forgotPasswordForm.emailPlaceholder')}
                        value={resetInput.email}
                        onChange={setReset('email')}
                        error={resetIdFieldError('email')}
                    />
                </Box>

                <Button
                    width='100' sizeUnit='%'
                    titleSize='1.6' fontWeight='600'
                    height='4.4' radius='0.8'
                    topMargin='3.5' bottomMargin='2' hoverColor='#0D968F'
                    hoverBgColor='#fff' borderColor='#0D968F'
                >
                    {t('login.forgotPasswordForm.sendOtpButton')}
                </Button>

                <AppText align='center'>
                    <AppLink
                        decoration='none' color='#1E1E1E'
                        fontWeight='600' hoverColor='#0D968F'
                        onClick={backToLogin}
                    >
                        {t('login.forgotPasswordForm.backToLogin')}
                    </AppLink>
                </AppText>
            </Form>
        </>
    )
}

export default ForgotPasswordForm